import React from 'react';
import PropTypes from 'prop-types';
import ButtonFactoryPreviewPPLogoHeader from './ButtonFactoryPreviewPPLogoHeader';
import CommonPreviewComponent from './CommonPreviewComponent';
import getLocaleMessages from '../../utils/localesMessages';
const messages = getLocaleMessages('buttonsV3/buttonPreview');

function ButtonFactoryV3DesktopPreview({
  isButtonOverviewPreview = false,
  showPPHeader = false,
}) {
  return (
    <div
      id="bf3_desktop_preview_wrapper"
      role="region"
      aria-label={messages.navigator.fullPage.desktopAccessibility}
    >
      {showPPHeader && <ButtonFactoryPreviewPPLogoHeader />}
      <div id="bf3_desktop_preview_main">
        <div
          id="bf3_desktop_preview_container"
          className={`${
            showPPHeader
              ? 'guest_form_preview_container'
              : 'landing_page_preview_container'
          }`}
        >
          <CommonPreviewComponent
            isButtonOverviewPreview={isButtonOverviewPreview}
          />
        </div>
      </div>
    </div>
  );
}

ButtonFactoryV3DesktopPreview.propTypes = {
  isButtonOverviewPreview: PropTypes.bool,
  showPPHeader: PropTypes.bool,
};

export default ButtonFactoryV3DesktopPreview;
